import React from 'react';
// Constants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  buildingPageAdditionalMeta,
  buildingPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import BuildingPageMainContainer from '../../components/building/BuildingPageMainContainer';
import GeneralHeader from '../../components/headers/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function BuildingPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Construction'
        desc={`Get in touch with ${CompanyName} for expert building services in ${LocationCity}. Whether you need a new build, renovation, or any other construction services, we’re here to help.`}
        keywords={`building, construction, new builds, renovations, ${CompanyName}, quotes, inquiries, ${LocationCity}, UK`}
        additionalMeta={buildingPageAdditionalMeta}
        structuredData={buildingPageStructuredData}
      />

      <div className='grid min-h-screen overflow-hidden bg-colour3 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <GeneralHeader ServiceName='Construction' bgImage={'bg-construction'} />

          {/* Main page content */}
          <BuildingPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default BuildingPage;
